module.exports = "././img/Interpreter-Symbol-Text-100.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/Interpreter-Symbol-Text-100.png
// module id = 812
// module chunks = 0